import * as React from 'react';
import noop from 'lodash/noop';
import styled, { css } from 'styled-components';
import OverflowMenuIcon from '@ad-scripts/presentation/components/common/icons/overflow_menu_icon';
import PopoverMenu, { PopoverMenuItem, usePopoverMenu } from '@ad-scripts/presentation/components/common/menu';
import { Link } from 'react-router-dom';
import { Button, Tooltip } from 'src/presentation/components/agent_desktop_components';
import { ButtonTypes } from '@ad-scripts/presentation/components/common/button';

type OverflowMenuProps = {
  children?: any;
  id?: string;
  isOpen?: Function;
  onClose?: Function;
  onOpen?: Function;
  onToggle?: Function;
  props?: any;
  setTargetRef?: Function;
  targetRef?: any;
  tooltipMessage?: string;
  className?: string;
};

const OverflowMenu = ({
  children,
  onToggle,
  setTargetRef,
  isOpen,
  onOpen = noop,
  onClose,
  targetRef,
  id,
  tooltipMessage,
  className,
  ...props
}: OverflowMenuProps) => {
  const renderOverflowButton = tooltipMessage ? (
    <Tooltip message={tooltipMessage}>
      <OverflowButton className={className} />
    </Tooltip>
  ) : (
    <OverflowButton className={className} />
  );

  return (
    <OverflowContainer {...props}>
      <ButtonWrapper aria-haspopup="true" data-aid={`overflowMenu-button-${id}`} onClick={onToggle} ref={setTargetRef}>
        {renderOverflowButton}
      </ButtonWrapper>
      <PopoverMenu
        data-aid={`overflowMenu-${id}`}
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        position="bottom"
        targetPosition="start"
        targetRef={targetRef}
      >
        {children}
      </PopoverMenu>
    </OverflowContainer>
  );
};

const OverflowContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 16px;
  height: 16px;
  position: relative;
`;

const ButtonWrapper = styled.div`
  cursor: pointer;
`;

export const OverflowButton = styled(OverflowMenuIcon)`
  cursor: pointer;
  fill: ${p => p.theme.colors.gray600};
  height: 16px;
  visibility: hidden;
  width: 16px;
`;

const OverflowMenuItem = styled(PopoverMenuItem).attrs(props => ({
  'data-aid': `overflowMenu-item${props.id ? `-${props.id}` : ''}`,
}))`
  visibility: visible;
  padding: 0;
`;

const itemStyle = css`
  text-decoration: none;
  padding: 8px 16px;
`;

const OverflowMenuLink = styled(Link)`
  color: ${p => p.theme.colors.black};
  ${itemStyle}
`;

const OverflowMenuButton = styled(Button).attrs(() => ({ type: ButtonTypes.TEXT }))`
  color: ${p => p.theme.colors.black};
  text-align: left;
  ${itemStyle}

  &:hover {
    color: ${p => p.theme.colors.black};
  }
`;

const OverflowMenuExternalLink = styled.a`
  color: ${p => p.theme.colors.black};
  ${itemStyle}
`;

// Static text would normally inherit the color from the container
const OverflowMenuText = styled.div`
  ${itemStyle}
`;

export {
  OverflowMenuButton,
  OverflowMenuExternalLink,
  OverflowMenuItem,
  OverflowMenuLink,
  OverflowMenuText,
  usePopoverMenu,
};

export default OverflowMenu;
